import type { PageHeaderComponent } from "../../types";
import { PageTitle } from "./PageTitle";

/** Page header renderer with main title. The small yellow underline accent
 *  echoes the InformationHub heading so every inner page reads as part of the
 *  same design system — quick brand cue, no extra layout cost. Delegates to the
 *  shared `PageTitle` so authored and migrated pages share one header look. */
export function PageHeaderRenderer({ component }: { component: PageHeaderComponent }) {
  const { title } = component.content;
  return <PageTitle title={title} />;
}
